export const LOADING_TYPES = {
  lazy: 'lazy',
  eager: 'eager',
} as const;
export type LoadingType = (typeof LOADING_TYPES)[keyof typeof LOADING_TYPES];

export const ASPECT_RATIOS = {
  none: 'none',
  square: 'square',
  landscape: 'landscape',
  portrait: 'portrait',
} as const;
export type AspectRatioScreenLg = (typeof ASPECT_RATIOS)[keyof typeof ASPECT_RATIOS];
export type AspectRatioScreenMd = (typeof ASPECT_RATIOS)[keyof typeof ASPECT_RATIOS];
export type AspectRatioScreenSm = (typeof ASPECT_RATIOS)[keyof typeof ASPECT_RATIOS];

export const PARENT_COMPONENT = {
  none: 'none',
  bannerImage: 'banner-image',
} as const;
export type ParentComponent = (typeof PARENT_COMPONENT)[keyof typeof PARENT_COMPONENT];
